import React, { useCallback, useEffect, useMemo } from 'react'
import { Grid, Form } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { updateShipmentFieldValue } from '../../actions'
import { convertDateToUTC, convertDateToUTCEpoch } from '../../../Helper/date'
import { useDispatch, useSelector } from 'react-redux'
import { useEvent } from '../../hooks/useEvent'
import {cancelReasonValues, amendReasonValues} from "../../../../components/util"
import {Dropdown, TextArea} from 'semantic-ui-react';
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import AmendmentReasons from './amendmentReasons'
import CopyLabelWithIcon from '../../../commonComponents/formComponents/copyLabelWithIcon' 
import { validation } from '../../util/cdsFieldPatterns';
import {addHeaderTabWarnings,deleteHeaderTabWarnings,
  intializeHeaderTabWarnings,intializePartiesTabWarnings,intializeValueBuildUpTabWarnings} from "../../actions/errorValidationActions";
import {getValidShipmentFields} from './helper';

export default function headerShipment(props) {

  const {
    badge, 
    isImportShipment, 
    fieldPattern, 
    validateError, 
    initHeaderTabValidationCDS,
    initItemsTabValidationCDS
  } = props

  const dispatch = useDispatch()
  const { saveForm } = useEvent('header', true)
  const declarationCategories =
    useSelector((state) => state.DropDownValues?.declarationCategories) || []
  const declarationDropdown = useSelector((state) => state.DropDownValues?.declaration) || []
  const declarationTypes = useSelector((state) => state.DropDownValues?.declarationTypes) || []

  const declarationCat=useSelector((state) => state.Shipment.declarationCat)
   const arrivalDate=useSelector((state) => state.Shipment.arrivalDate)
   const departureDate=useSelector((state) => state.Shipment.departureDate)
   const exitEuDate=useSelector((state) => state.Shipment.exitEuDate)
   const declaration=useSelector((state) => state.Shipment.declaration)
   const ducr=useSelector((state) => state.Shipment.ducr)
   const ucn=useSelector((state) => state.Shipment.ucn)
   const lrn=useSelector((state) => state.Shipment.lrn)
   const mucr=useSelector((state) => state.Shipment.mucr)
   const specificCircumstanceIndicator=useSelector((state) => state.Shipment.specificCircumstanceIndicator)
   const acceptanceDate=useSelector((state) => state.Shipment.acceptanceDate)
   const releaseDate=useSelector((state) => state.Shipment.releaseDate)
   const referenceNumber=useSelector((state) => state.Shipment.referenceNumber)
   const declarationType=useSelector((state) => state.Shipment.declarationType)
   const cancellationReason=useSelector((state) => state.Shipment.cancellationReason)
  const shipmentValues = useSelector((state)=>state.Shipment)|| {}
  const shipmentData = useCurrentShipmentType()
  const AmendState = shipmentData?.currentJobState?.includes("AMEND")
  const {serviceType} = useCurrentShipmentType()


  const declarationErr = useSelector(state=>state.ValidationErrors?.header?.[`declaration`]?.msg)
  const declarationTypeErr = useSelector(state=>state.ValidationErrors?.header?.[`declarationType`]?.msg)
  const referenceNumberErr = useSelector(state=>state.ValidationErrors?.header?.[`referenceNumber`]?.msg)
  const specificCircumstanceIndicatorErr = useSelector(state=>state.ValidationErrors?.header?.[`specificCircumstanceIndicator`]?.msg)


  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'headerTab'),
    [declarationCat]
  )
  useEffect(()=>{
    if(serviceType==="IM"){
    if(!badge){
      dispatch(updateShipmentFieldValue({ ucn:''}))
      saveForm({
        ucn: ' '})
      }
         let err =  !!badge ? getValidationError('ucn', ucn, 'headerTab') : []
         err.length 
                  ? addErrors('headerTab', err[0], 'ucn')
                  : deleteErrors('headerTab', '', 'ucn')
                  
    }
  },[badge])


  const addErrors = (level, value, fieldName) => {
      dispatch(addHeaderTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteHeaderTabWarnings(level, value, fieldName))
  }
  const updateWarningWindow = (declarationCat) =>{
    const data = getValidShipmentFields(shipmentValues)
    if(!declarationCat || serviceType==="EX")return
    dispatch(intializeHeaderTabWarnings('headerTab',{header :data},declarationCat,badge))
    dispatch(intializePartiesTabWarnings('partiesTab',data,declarationCat))
  }

  return (
    <React.Fragment>
       { AmendState && <AmendmentReasons /> }
    <Form.Group className='float-container'>
      <Grid className='kn__grid'>
        {
        cancellationReason && 
        <Grid.Row>
          <Grid.Column width={16}>
          {
            cancellationReason && 
            <><label for="floatField" title="DUCR" class="name-label es">Cancel Reason(s)</label>
            <Dropdown
              label={`Reason`}
              lazyLoad={true}
              style={{
                  width: "100%",
                  border: "1px solid rgb(91 156 206)",
                  paddingTop: "21px"
              }}
              id="cancelReason"
              data="cancelReason"
              value={cancellationReason}
              options={cancelReasonValues}
              placeholder="Select Reasons"
              fluid
              multiple
              selection
              disabled
              /></>
          }
          </Grid.Column>
        </Grid.Row>
        }
        <Grid.Row>
          <Grid.Column width='3' className='divFormFeild'>
            <DropDown
              id='declarationCat'
              label='Declaration Category'
              className='field-bg dropdown100'
              labelClass='text-none'
              isLabel={true}
              data={declarationCategories}
              value={declarationCat}
              errors={!!declarationCat ? [] : ["DECLARATION CATEGORY is mandatory."]}
              onChange={(value) => {
                saveForm({
                  declarationCat: value || ' ',
                })
                updateWarningWindow(value)
                dispatch(updateShipmentFieldValue({ declarationCat: value }))
                dispatch(initHeaderTabValidationCDS())
                dispatch(initItemsTabValidationCDS())
              }}
            />
          </Grid.Column>
          <Grid.Column width='3' className='divFormFeild'>
            <DropDown
              id='declaration'
              label='Declaration'
              className='field-bg dropdown100'
              labelClass='text-none'
              isLabel={true}
              clearable 
              data={declarationDropdown}
              boxNumber='1/1'
              value={declaration}
              errors={isImportShipment ? getValidationError("declaration",declaration,true) :declarationErr} // M
              onChange={(value) => {
                saveForm({
                  declaration: value||' ',
                })                
                validateError(
                  {declaration:"",declarationCat:""},
                  {declaration:value,declarationCat:declarationCat},
                  {declaration:fieldPattern()?.header[`declaration`],declarationCat:fieldPattern()?.header['declarationCat']}) // M
                let err = getValidationError('declaration', value, 'headerTab',true)
                err.length
                  ? addErrors('headerTab', err[0], 'declaration')
                  : deleteErrors('headerTab', '', 'declaration')
                dispatch(updateShipmentFieldValue({ declaration: value }))
              }}
            />
          </Grid.Column>
          <Grid.Column width='3' className='divFormFeild'>
            <DropDown
              id='declarationType'
              label='Declaration Type'
              className='field-bg dropdown100'
              labelClass='text-none'
              isLabel={true}
              clearable
              data={declarationTypes}
              boxNumber='1/2'
              value={declarationType}
              errors={isImportShipment ? getValidationError("declarationType",declarationType,true) : declarationTypeErr}
              onChange={(value) => {
                saveForm({
                  declarationType: value || ' ',
                })
                validateError({declarationType:"",declarationCat:''},
                {declarationType:value,declarationCat:declarationCat},
                {declarationType:fieldPattern()?.header[`declarationType`],declarationCat:fieldPattern()?.header['declarationCat']}) // M
               dispatch(updateShipmentFieldValue({ declarationType: value }))
               let err = getValidationError('declarationType', value, 'headerTab',true)
                err.length
                  ? addErrors('headerTab', err[0], 'declarationType')
                  : deleteErrors('headerTab', '', 'declarationType')
              }}
            />
          </Grid.Column>
          <Grid.Column width='3' className='divFormFeild'>
            <InputField
              isLabel={false}
              id='ducr'
              type='text'
              label='ducr'
              className='field-bg'
              value={ducr}
              errors={getValidationError("ducr",ducr)}
              clearInput={false}
              boxNumber='2/1'
              onChange={(value) => {
                dispatch(updateShipmentFieldValue({ ducr: value }))
              }}
              onBlur={(value) => {
                saveForm({
                  ducr: value || " ",
                })
                let err = getValidationError('ducr', ducr, 'headerTab') 
                err.length
                  ? addErrors('headerTab', err[0], 'ducr')
                  : deleteErrors('headerTab', '', 'ducr')
              }}
              disabled={false}
            />
          </Grid.Column>
          <Grid.Column width='4' className='divFormFeild'>
            {serviceType ==="EX"?
            <InputField
            isLabel={false}
            id='mucr'
            type='text'
            label="MUCR"
            className='field-bg'
            value={mucr}
            clearInput={false}
            boxNumber='2/1'
            disabled={false}
            onChange={(value) => {
              dispatch(updateShipmentFieldValue({ mucr: value }))
            }}
            onBlur={(value) => {
              saveForm({
                mucr: value || " ",
              })
             }}
            />
            :
            <InputField
              isLabel={false}
              id='ucn'
              type='text'
              label={<CopyLabelWithIcon label="ucn"  fieldInfo={ucn} />}
              className='field-bg'
              value={ucn}
              errors={!!badge ?getValidationError("ucn",ucn):[]}
              clearInput={false}
              boxNumber='2/1'
              onChange={(value ) => {
                dispatch(updateShipmentFieldValue({ ucn: value }))
                let err =  getValidationError('ucn', ucn, 'headerTab') 
                err.length 
                  ? addErrors('headerTab', err[0], 'ucn')
                  : deleteErrors('headerTab', '', 'ucn')
              }}
              onBlur={(value) => {
                saveForm({
                  ucn: value || ' ',
                })
                let err =  getValidationError('ucn', ucn, 'headerTab')
                err.length 
                  ? addErrors('headerTab', err[0], 'ucn')
                  : deleteErrors('headerTab', '', 'ucn')
              }}
              disabled={!badge ? true:false}
            />
            }
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width='4' className='divFormFeild b-bw-1'>
            <InputField
              isLabel={false}
              id='shipmentNumber'
              type='text'
              label='Shipment Number / Lrn'
              className='field-bg'
              value={lrn}
              clearInput={false}
              boxNumber='2/5'
              onChange={(value) => {
                dispatch(updateShipmentFieldValue({ lrn: value }))
              }}
              onBlur={(value) => {
                saveForm({
                  lrn: value||' ',
                })
        
              }}
              disabled={true}
            />
          </Grid.Column>
          <Grid.Column width='4' className='divFormFeild datepicker1 b-bw-1'>
            {serviceType==="EX"?
            <InputField
            isLabel={false}
            id='departureDate'
            label='Departure date'
            type='date'
            className='field-bg'
            value={convertDateToUTC(departureDate.epochs) || ''}
            clearInput={false}
            onChange={(value) => {
              value = convertDateToUTCEpoch(value)
              saveForm({
                departureDate: { epochs: value || ' ' },
              })
              dispatch(updateShipmentFieldValue({ departureDate: { epochs: value } }))
            }}
            disabled={false}
            />
            :
            <InputField
              isLabel={false}
              id='arrivalDate'
              label='Arrival date'
              type='date'
              className='field-bg'
              value={convertDateToUTC(arrivalDate.epochs) || ''}
              clearInput={false}
              onChange={(value) => {
                value = convertDateToUTCEpoch(value)
                saveForm({
                  arrivalDate: { epochs: value || ' ' },
                })
                dispatch(updateShipmentFieldValue({ arrivalDate: { epochs: value } }))
              }}
              isDisabled={window.typeOfUser === 'BROKER_KN_ADMIN' ? true : false}
            />}
          </Grid.Column>
          <Grid.Column width='4' className='divFormFeild datepicker1 b-bw-1'>
            <InputField
              isLabel={false}
              id='acceptDate'
              type='date'
              label='Acceptance date'
              className='field-bg'
              value={convertDateToUTC(acceptanceDate.epochs)}
              clearInput={false}
              onChange={(value) => {
                value = convertDateToUTCEpoch(value)
                saveForm({
                  acceptanceDate: { epochs: value},
                })
                dispatch(updateShipmentFieldValue({ acceptanceDate: { epochs: value } }))
              }}
              disabled={true}
            />
          </Grid.Column>
          <Grid.Column width='4' className='divFormFeild datepicker1 b-bw-1'>
            <InputField
              isLabel={false}
              id='realeaseDate'
              type='date'
              label='Release date'
              className='field-bg'
              value={convertDateToUTC(releaseDate.epochs)}
              clearInput={false}
              onChange={(value) => {
                value = convertDateToUTCEpoch(value)
                saveForm({
                  releaseDate: { epochs: value},
                })
                dispatch(updateShipmentFieldValue({ releaseDate: { epochs: value } }))
              }}
              disabled={true}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={serviceType==="EX"?'6':'16'} className='divFormFeild b-bw-1'>
            <InputField
              isLabel={false}
              id='referenceNum'
              type='text'
              label='Reference Number / Ucr'
              className='field-bg'
              value={referenceNumber}
              errors={isImportShipment ? getValidationError("referenceNumber",referenceNumber): referenceNumberErr} // M
              boxNumber='2/4'
              clearInput={false}
              onChange={(value) => {
                dispatch(updateShipmentFieldValue({ referenceNumber: value }))
              }}
              onBlur={(value) => {
                validateError({referenceNumber:""},{referenceNumber:value},{referenceNumber:fieldPattern()?.header[`referenceNumber`]})
                saveForm({
                  referenceNumber: value||' ',
                })
              }}
              disabled={false}
            />
          </Grid.Column>
          {serviceType==="EX"&&
          <Grid.Column width='5' className='divFormFeild'>
            <InputField
              isLabel={false}
              id='specificCircumstanceIndicator'
              type='text'
              label='SPECIFIC CIRCUMSTANCE INDICATOR'
              className='field-bg'
              value={specificCircumstanceIndicator}
              errors={specificCircumstanceIndicatorErr}
              boxNumber='1/7'
              clearInput={false}
              onChange={(value) => {
                dispatch(updateShipmentFieldValue({ specificCircumstanceIndicator: value }))
              }}
              onBlur={(value) => {  
                saveForm({
                  specificCircumstanceIndicator: value||' ',
                })
              }}
              disabled={false}
            />
          </Grid.Column>}
          {serviceType==="EX"&&
          <Grid.Column width='5' className='divFormFeild datepicker1 b-bw-1'>
          <InputField
          isLabel={false}
          id='exitEUDate'
          label='EXIT EU DATE'
          type='date'
          className='field-bg'
          value={convertDateToUTC(exitEuDate.epochs) || ''}
          clearInput={false}
          onChange={(value) => {
            value = convertDateToUTCEpoch(value)
            saveForm({
              exitEuDate: { epochs: value},
            })
            dispatch(updateShipmentFieldValue({ exitEuDate: { epochs: value } }))
          }}
          disabled={false}
          />
          </Grid.Column>
            }
        </Grid.Row>
      </Grid>
    </Form.Group>
    </React.Fragment>
  )
}
